import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilityService } from './utility.service';
import { Vendor } from '../models/Vendor';
import { environment } from '../../environments/environment';
import { DynamicFormUtilityServices } from './dynamic-form-utility.service';
import { DuplicateVendorView } from '../models/DuplicateVendorView';
import { DynamicFormView } from '../models/DynamicFormView';

@Injectable({
  providedIn: 'root',
})
export class VendorFormService {
  private readonly urlPath = 'vendor';

  constructor(
    private httpClient: HttpClient,
    private utilityService: UtilityService,
    private dynamicFormUtilityServices: DynamicFormUtilityServices,
  ) {}

  createForm(request: any, prefix: string): Observable<Vendor> {
    return this.httpClient
      .post<Vendor>(
        `${environment.apiUrl}vendor-registration`,
        this.setupRequest(request, prefix),
      )
      .pipe();
  }

  private setupRequest(request: any, prefix: string) {
    const formData: FormData = new FormData();
    formData.append('vendor W9', request.vendorW9File);
    formData.append('voided Check', request.voidedCheckFile);
    formData.append('model', JSON.stringify(request));
    for (let i = 0; i < request.attachments.length; i++) {
      const name = `additional file -${i + 1}`;
      formData.append(name, request.attachments[i].file);
      request.attachments[i].name = name;
    }

    this.dynamicFormUtilityServices.appendDocuments(formData, prefix, request);
    return formData;
  }

  getForm(id: string): Observable<Vendor> {
    return this.httpClient
      .get<Vendor>(`${environment.apiUrl}vendor-registration/${id}`)
      .pipe();
  }

  checkDuplicateVendors(params: {
    id: string;
    socialSecurityNumber: string;
    employerIdentificationNumber: string;
  }): Observable<DuplicateVendorView[]> {
    return this.httpClient
      .post<
        DuplicateVendorView[]
      >(`${environment.apiUrl}vendor-registration/check-duplicates-vendors`, params)
      .pipe();
  }

  getAllForm(clientId: string): Observable<DynamicFormView[]> {
    return this.httpClient
      .get<
        DynamicFormView[]
      >(`${environment.apiUrl}vendor-registration/dynamic-form`)
      .pipe();
  }
}
